import Radio from './Radio';

export default Radio;
export type { IRadioProps } from './Radio';
